(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.common.components.skypecallbutton.viewer.skins.SkypeCallButtonSkin'] = {
  "react": [
    [
      "a",
      "skypeLink",
      [],
      {},
      [
        "div",
        "placeholder",
        [],
        {}
      ]
    ]
  ],
  "css": {
    "%placeholder": "background-repeat:no-repeat;background-size:cover;",
    "%[data-state~=\"call\"][data-state~=\"small\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_trans_16px.png);",
    "%[data-state~=\"call\"][data-state~=\"small\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_16px.png);",
    "%[data-state~=\"call\"][data-state~=\"medium\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_trans_24px.png);",
    "%[data-state~=\"call\"][data-state~=\"medium\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_24px.png);",
    "%[data-state~=\"call\"][data-state~=\"large\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_trans_32px.png);",
    "%[data-state~=\"call\"][data-state~=\"large\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/callbutton_32px.png);",
    "%[data-state~=\"chat\"][data-state~=\"small\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_trans_16px.png);",
    "%[data-state~=\"chat\"][data-state~=\"small\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_16px.png);",
    "%[data-state~=\"chat\"][data-state~=\"medium\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_trans_24px.png);",
    "%[data-state~=\"chat\"][data-state~=\"medium\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_24px.png);",
    "%[data-state~=\"chat\"][data-state~=\"large\"][data-state~=\"white\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_trans_32px.png);",
    "%[data-state~=\"chat\"][data-state~=\"large\"][data-state~=\"blue\"] %placeholder": "background-image:url(https://secure.skypeassets.com/i/scom/images/skype-buttons/chatbutton_32px.png);",
    "%skypeLink": "display:block;height:100%;"
  }
}

        return skins;
    }));